import React, { useEffect } from "react";
import { TextField } from "@material-ui/core";
import PropTypes from "prop-types";

export default function TCover(props) {
  const { answers, getJson } = props;
  const categoryId = 1;
  const type = "TCover";

  useEffect(() => {
    if (answers.length <= 0) {
      getJson({ categoryId, type, answers: [{ selected: "Contestado" }] });
    }
  }, [answers, getJson]);

  return <TextField disabled fullWidth type="text" label="Texto Informativo" />;
}

TCover.propTypes = {
  answers: PropTypes.array.isRequired,
  getJson: PropTypes.func,
};
